import { render } from "./BookMenu.vue?vue&type=template&id=478bef08&scoped=true"
import script from "./BookMenu.vue?vue&type=script&lang=js"
export * from "./BookMenu.vue?vue&type=script&lang=js"

import "./BookMenu.vue?vue&type=style&index=0&id=478bef08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478bef08"]])

export default __exports__